module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Regular.7ea9972.ttf";